"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  SvgIcon: true
};
exports.default = exports.SvgIcon = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _helpers = require("./_helpers");
var _SvgIconSource = require("./_SvgIconSource");
var _SvgIcon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SvgIcon.css") : void 0);
var _SvgIcon2 = require("./_SvgIcon.types");
Object.keys(_SvgIcon2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SvgIcon2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SvgIcon2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-svg-icon';
const SvgIcon = exports.SvgIcon = /*#__PURE__*/_react.default.forwardRef((_a, ref) => {
  var {
      ariaHidden,
      className,
      iconName,
      path1ClassName,
      path2ClassName,
      size = 'sm',
      title
    } = _a,
    otherProps = __rest(_a, ["ariaHidden", "className", "iconName", "path1ClassName", "path2ClassName", "size", "title"]);
  const classnames = _bind.default.bind(_SvgIcon.default);
  const classes = classnames(CSS_BLOCK, className);
  const path1Classes = classnames(`${CSS_BLOCK}__path1`, `${CSS_BLOCK}__path1--${iconName}`, path1ClassName);
  const path2Classes = classnames(`${CSS_BLOCK}__path2`, `${CSS_BLOCK}__path2--${iconName}`, path2ClassName);
  const iconSize = (0, _helpers.getIconPixelSize)(size);
  const viewBox = '0 0 24 24';
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({}, otherProps, {
    role: !ariaHidden ? 'img' : undefined,
    "aria-hidden": !!ariaHidden,
    className: classes,
    height: iconSize,
    version: "1.1",
    viewBox: viewBox,
    width: iconSize,
    x: "0px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    y: "0px",
    ref: ref
  }), title && /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement(_SvgIconSource.SvgIconSource, {
    iconName: iconName,
    path1ClassName: path1Classes,
    path2ClassName: path2Classes
  }));
});
SvgIcon.displayName = 'SvgIcon';
var _default = exports.default = SvgIcon;